import React from 'react'
import { connect } from 'react-redux'
import EmailForm from './EmailForm'
import ProfileForm from './ProfileForm'
import TermsForm from './TermsForm'
import l8n from 'l8n'

const mapStateToProps = (state) => {
  const { googleIdToken, email, password, termsAccepted } = state.registration;
  return {
    emailReceived: googleIdToken || (email && password),
    termsAccepted: termsAccepted,
  }
};

@connect(mapStateToProps)
class RegistrationForm extends React.Component {
  render = () => {
    const {emailReceived, termsAccepted} = this.props
    const mustAcceptTerms = l8n.locale !== 'ru'

    if (! emailReceived) {
      return <EmailForm />
    }

    if (mustAcceptTerms && ! termsAccepted) {
      return <TermsForm />
    }

    return <ProfileForm />
  }
}

export default RegistrationForm



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/RegistrationForm/index.js